export const typeLabel = type => (type === "NESTING" ? "Nesting" : "Normal");

export const statusLabel = status =>
    ({
        WAITING: "Aguardando",
        INPROGRESS: "Em andamento",
        IN_PROGRESS: "Em andamento",
        FINISHED: "Finalizado",
        CANCELLED: "Cancelado"
    }[status] || status);

export const statusClass = status =>
    ({
        WAITING: "status--waiting",
        INPROGRESS: "status--progress",
        IN_PROGRESS: "status--progress",
        FINISHED: "status--finished",
        CANCELLED: "status--cancelled"
    }[status] || "status--waiting");

export const allocationLabel = allocation =>
    ({
        NONE: "Manual",
        PLANNEDQUANTITY: "Quantidade planejada",
        PLANNED_QUANTITY: "Quantidade planejada",
        PERCENTAGE: "Percentual",
        FIXEDQUANTITY: "Quantidade fixa",
        FIXED_QUANTITY: "Quantidade fixa"
    }[allocation] || allocation);

export const apiErrorMessage = error => {
    const data = error?.response?.data;
    return data?.message || data?.errors?.[0]?.message || "Não foi possível concluir a operação.";
};
